import snakecaseKeys from 'snakecase-keys'
import client from '../../client'
import {
  ReviewId,
  Review,
  CreateReviewParams,
  UpdateReviewParams,
} from './types'
import { ApiResponse } from '../../types'

export * from './types'

export const get = async (id: ReviewId): Promise<Review> => {
  const { data }: ApiResponse<Review> = await client.get(`/user/reviews/${id}`)
  return data
}

export const create = (params: CreateReviewParams) => {
  const { timetableId, scores, comment } = params

  return client.post('/user/reviews', {
    timetable_id: timetableId,
    scores: snakecaseKeys(scores),
    comment,
  })
}

export const update = (id: ReviewId, params: UpdateReviewParams) => {
  const { timetableId, scores, comment } = params

  return client.put(`/user/reviews/${id}`, {
    timetable_id: timetableId,
    scores: snakecaseKeys(scores),
    comment,
  })
}
